export default function SlideInFooter({
  children,
}: {
  children: React.ReactNode
}) {
  return <div className="slidein__footer">{children}</div>
}
